// import { lazy } from "react";

// // Authentication related pages
// import Landing from "../pages/Auth/index";
// import MainLayout from '../components/Layout/layout'
import Login from "../pages/Auth/login";
import Register from "../pages/Auth/register";
// const Login = lazy(() => import("../pages/Auth/index"));
// // const Landing = lazy(() => import("../pages/Landing/index"));

//Dashboard
import Dashboard from "../pages/Dashboard/index";
import MyAccount from "../pages/My-Account/index";
import NotFound from "../pages/NotFoundPage/index";
import Questions from "../pages/FAQ/index";
import Terms from "../pages/TermsConditions/index";
import ContactUs from "../pages/Static-pages/ContactUs/index";
// import AboutProgram from "../pages/AboutProgram/index";
import Landing from "../pages/Landing";
import Packages from "../pages/Packges";
import PackageDetailsList from "../pages/PackgesDetails/index";
import Activities from "../pages/Activities";
// import ActivitiesList from "../pages/Activities/activity-list";
import AboutUs from "../pages/Static-pages/About-us";
import Careers from "../pages/Static-pages/Careers";
import FrequentAsked from "../pages/FAQ/index";
import singleActivitiesList from "../pages/Activities/single-activities-list";
import TravellerDetails from "../pages/TravellerDetails/index";
import EnquiryDetails from "../pages/TravellerDetails/enquire";
import stateActivitiesList from "../pages/Activities/state-activities-list";
import cityActivitiesList from "../pages/Activities/city-activities-list";
import Cabs from "../pages/Cabs";
// const Dashboard = lazy(() => import("../pages/Dashboard/index"));
// const MyAccount = lazy(() => import("../pages/My-Account/index"));
// const NotFound = lazy(() => import("../pages/NotFoundPage/index"));

const authProtectedRoutes = [
  { path: "/", exact: true, component: Landing },
  // { path: "/packages", exact: true, component: Packages },
  { path: "/packages/:id?", exact: true, component: Packages },
  { path: "/not-found", exact: true, component: NotFound },
  { path: "/package-details/:id?", exact: true, component: PackageDetailsList },
  { path: "/destinations", exact: true, component: Activities },
  { path: "/cab-details", exact: true, component: Cabs },
  {
    path: "/destinations/destination:id?",
    exact: true,
    component: stateActivitiesList,
  },
  // { path: "/destinations/destination:id?", exact: true, component: ActivitiesList },
  {
    path: "/destinations/destination:id?/:id?",
    exact: true,
    component: cityActivitiesList,
  },
  {
    path: "/destinations/destination-in-:id?/:id?/:id?/:id?",
    exact: true,
    component: singleActivitiesList,
  },
  {
    path: "/booking/travellers/:id?",
    exact: true,
    component: TravellerDetails,
  },

  { path: "/home", exact: true, component: Dashboard },
  { path: "/my-account", exact: true, component: MyAccount },
  { path: "/faq", component: Questions },
  { path: "/terms-conditions", component: Terms },
  { path: "/contact-us", component: ContactUs },
  { path: "/about-us", component: AboutUs },
  { path: "/faq", component: FrequentAsked },
  { path: "/careers", component: Careers },
];

const publicRoutes = [
  // { path: "/", exact: true, component: Dashboard },
  // { path: "/:id?", exact: true, component: Landing },
  // { path: "/:id", exact: true, component: Landing },
  // { path: "/", exact: true, component: Landing },
  { path: "/create-account", component: Register },
  // { path: "/create-account/:id?", component: Register },
  { path: "/login", component: Login },
  // { path: "/login/:id", component: Login },
  // { path: "/create-account/:id", component: Register },
  { path: "/faq", component: Questions },
  { path: "/terms_Condition", component: Terms },
  { path: "/contact-us", component: ContactUs },
  { path: "/about-us", component: AboutUs },
  {
    path: "/enquiry/:id?",
    exact: true,
    component: EnquiryDetails,
  },
];

export { authProtectedRoutes, publicRoutes };
